import { z } from 'zod';

import { ForeclosureId } from '../BrandedIds';
import { zodJSPlainDate } from '../dates/BrandedDate';
import { ForeclosureOutcome, ForeclosureStatus } from '../loan/Foreclosure';
import { ReportableEventInput } from '../loan/ReportableEvent';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CloseForeclosureEvent = BaseLoanEvent.extend({
  type: z.literal('closeForeclosure'),
  foreclosureId: ForeclosureId,
  status: ForeclosureStatus,
  endOutcome: ForeclosureOutcome.optional(),
  endDate: zodJSPlainDate.optional(),
  reportableEvent: ReportableEventInput.optional(),
  comment: z.string().optional(),
});
export type CloseForeclosureEvent = z.infer<typeof CloseForeclosureEvent>;
